import { parseMessyNumber, roundCurrency } from 'common/Utils/NumberUtilities'
import { voucherTypes } from 'pages/DiscountVoucher/VoucherTypes'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

const OrderSummary = ({
	t,
	productions,
	orderId,
	orderName,
	orderNumber,
	orderDate,
	partsPrice,
	fee,
	shipmentPrice,
	discount,
	vouchers,
	subtotal,
	taxes,
	totalPrice,
	paymentMethod,
	productionPeriod,
	estimatedShippingDate,
	realShippingDate,
	totalImportCost,
	totalWeight,
	setModalInternalCustomerCommentIsOpen,
	setModalType
}) => {

	const discountVoucher = vouchers.filter(v => [voucherTypes.AMOUNT, voucherTypes.PERCENTAGE].includes(v.voucherTypeId))[0]
	const freeShippingVoucher = vouchers.filter(v => v.voucherTypeId == voucherTypes.FREE_SHIPPING)[0]
	const noMinimumPriceVoucher = vouchers.filter(v => v.voucherTypeId == voucherTypes.NO_MINIMUM_PRICE)[0]
	const giftVoucher = vouchers.filter(v => v.voucherTypeId == voucherTypes.GIFT)[0]

	const totalCostOfAllProductions = productions.reduce((acc, production) => {
		return acc + production.purchasePrice + production.shipmentPrice
	}, 0)

	const balanceTotal = parseMessyNumber(subtotal) - totalCostOfAllProductions
	return (
		<div className="p-4">
			<div className="d-flex flex justify-content-between">
				<h3>{`${t('order', { ns: 'naming' })} ${orderId}`}</h3>
				<div style={{marginInlineStart: '70px'}}>
					{orderName ? <div className='d-flex align-items-center'><h5>{`${orderName}`}</h5>
					<button style={{
							border: '1px solid',
							borderColor: 'transparent',
							borderRadius: '4px',
							color: 'orange',
							backgroundColor: 'transparent',
							width: '30px',
							height: '30px',
					
							}} onClick={() => {
								setModalInternalCustomerCommentIsOpen(true)
								setModalType("internalOrderComment")
							}}>
						<i className='bx bxs-pencil' style={{fontSize: '15px'}}></i>
					</button></div> : <div className='d-flex w-55'>
					
					<button className='btn btn-primary' style={{padding: '4px'}} onClick={() => {
								setModalInternalCustomerCommentIsOpen(true)
								setModalType("internalOrderComment")
							}}>
						
						{t('customer_internal_order_comment', { ns: 'naming' })}
					</button></div>}
					{orderNumber ? <div className='d-flex mt-3 align-items-center'><h5>{`${orderNumber}`}</h5>
					<button style={{
							border: '1px solid',
							borderColor: 'transparent',
							borderRadius: '4px',
							color: 'orange',
							backgroundColor: 'transparent',
							width: '30px',
							height: '30px',
							marginRight: '8px'
							}} onClick={() => {
								setModalInternalCustomerCommentIsOpen(true)
								setModalType("internalOrderNumber")
							}}>
						<i className='bx bxs-pencil' style={{fontSize: '15px'}}></i>
					</button></div>  : <div className='d-flex w-55'>
					<button className='btn btn-primary mt-1 w-100' style={{padding: '3px', }} onClick={() => {
								setModalInternalCustomerCommentIsOpen(true)
								setModalType("internalOrderNumber")
							}}>
						
						{t('customer_internal_order_number', { ns: 'naming' })}
					</button></div>}
				</div>
			</div>
			<p>
				<strong>{t('orderDate', { ns: 'naming' })}</strong>
				<br />
				{orderDate}
			</p>
			<p>
				<strong>{t('totalPrice', { ns: 'naming' })}</strong>
				<br />{t('partsPrice', { ns: 'naming' })}: {roundCurrency(partsPrice)}€
				<br />{t('fee', { ns: 'naming' })}: {noMinimumPriceVoucher ? <span>
					<span className="text-decoration-line-through">{roundCurrency(fee)}€</span>
					<span className="mx-2 px-1 bg-cyan rounded-1 text-white p-0 m-4">{noMinimumPriceVoucher.code}</span>
				</span> : <span>{roundCurrency(fee)}€</span>}
				<br />{t('shipmentPrice', { ns: 'naming' })}: {freeShippingVoucher ? <span>
					<span className="text-decoration-line-through">{roundCurrency(shipmentPrice)}€</span>
					<span className="mx-2 px-1 bg-cyan rounded-1 text-white">{freeShippingVoucher.code}</span>
				</span> : <span>{roundCurrency(shipmentPrice)}€</span>}
				<br />{t('discount', { ns: 'naming' })}: <span>
					<span>{roundCurrency(discount)}€</span>
					{discountVoucher && <span className="mx-2 px-1 bg-cyan rounded-1 text-white">{discountVoucher.code}</span>}
				</span>
				<br /><strong>{t('Subtotal', { ns: 'naming' })}: {roundCurrency(subtotal)}€</strong>
				<br />{t('taxes', { ns: 'naming' })}: {roundCurrency(taxes)}€
				<br />{t('total', { ns: 'naming' })}: {roundCurrency(totalPrice)}€
			</p>
			<p>
				<strong>{t('paymentMethod', { ns: 'naming' })}</strong>
				<br />
				{paymentMethod}
			</p>
			<p>
				<strong>{t('productionTime', { ns: 'naming' })}</strong>
				<br />
				{productionPeriod} {productionPeriod ? productionPeriod > 1 ? t('workingDays', { ns: 'naming' }) : t('workingDay', { ns: 'naming' }) : ''}
			</p>
			<p>
				<strong>{t('customerShipmentDate', { ns: 'naming' })}</strong>
				<br />
				{estimatedShippingDate ? estimatedShippingDate : '-'} {`(${t('estimated', { ns: 'naming' })})`}
				<br />
				{realShippingDate && <strong>{realShippingDate} ({t('real', { ns: 'naming' })})</strong>}
			</p>
			<p>
				<strong>{t('totalImportCost', { ns: 'naming' })}</strong>
				<br />
				{roundCurrency(totalImportCost)} €
			</p>
			<p>
				<strong>{t('production_costs', { ns: 'naming' })}</strong>
				<br />
				{roundCurrency(totalCostOfAllProductions.toFixed(2))} €
			</p>
			<p>
				<strong>{t('balanceTotal', { ns: 'naming' })}</strong>
				<br />
				{roundCurrency(balanceTotal.toFixed(2))} €
			</p>
			<p>
				<strong>{t('totalWeight', { ns: 'naming' })}</strong>
				<br />
				{totalWeight}
			</p>
			{giftVoucher && <p>
				<strong>{t('include-gift', { ns: 'naming' })}</strong><span className="mx-2 px-1 bg-cyan rounded-1 text-white">{giftVoucher.code}</span>
			</p>}

		</div>
	)
}
OrderSummary.propTypes = {
	t: PropTypes.func,
	orderId: PropTypes.number,
	orderName: PropTypes.string,
	orderNumber: PropTypes.string,
	orderDate: PropTypes.string,
	partsPrice: PropTypes.string,
	fee: PropTypes.string,
	shipmentPrice: PropTypes.string,
	discount: PropTypes.string,
	vouchers: PropTypes.array,
	subtotal: PropTypes.string,
	taxes: PropTypes.string,
	totalPrice: PropTypes.string,
	paymentMethod: PropTypes.string,
	productionPeriod: PropTypes.number,
	estimatedShippingDate: PropTypes.string,
	realShippingDate: PropTypes.string,
	setModalInternalCustomerCommentIsOpen: PropTypes.func,
	setModalType: PropTypes.func
}
export default withTranslation()(OrderSummary)
